import React from 'react'
import EvaluatorHome from '../Company/CompanyHome/EvaluatorHome'
import All from '../Company/Ranking/All'

function Ranking() {
  return (
    <>
        <All />
    </>
  )
}

export default Ranking
